import React from "react";
import styles from "../Form.module.scss";

function RadioInput({ substep, value, onChange, error, isReadOnly, options }) {
  const selected = value?.string_value ?? "";

  const pick = (optValue) => {
    if (isReadOnly) return;
    onChange(substep.substep_id, { string_value: optValue });
  };

  return (
    <div className={styles.fieldBody}>
      <div className={styles.radioGroup}>
        {options.map((opt) => {
          const isSel = selected === opt.value;
          return (
            <div
              key={opt.value}
              className={`${styles.radioOption} ${isSel ? styles.radioOptionSel : ""}`}
              onClick={() => pick(opt.value)}
              role="radio"
              aria-checked={isSel}
              tabIndex={0}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && pick(opt.value)}
            >
              <span className={styles.radioCircle} />
              <span>{opt.label}</span>
            </div>
          );
        })}
      </div>
      {error && <div className={styles.fieldError}>{error}</div>}
    </div>
  );
}

export default RadioInput;
